import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from './AuthContext'
import { withSearch } from './SearchContext'
import styled from 'styled-components'
import { shouldTranslateTo } from '../utils/utils'
// import Modal from "./Signup";
import { decode } from 'html-entities'

import {
  Title,
  Subtitle,
  Button,
  CustomSubtitle,
  ContainerFlexRow,
} from './Utils/CustomClasses'

const Container = styled.div`
  margin-top: -10px;

  @media screen and (max-width: 992px) and (min-width: 769px) {
    margin-top: 150px;
  }

  @media screen and (max-width: 768px) and (min-width: 426px) {
    margin-top: -20px;
  }

  @media screen and (max-width: 425px) {
    margin-top: -15px;
  }
`

const Header = styled.div`
  background-color: #f6f0e6;
`

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  justify-content: space-evenly;
  align-items: center;

  @media screen and (max-width: 1024px) {
    flex-direction: row;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const HeaderText = styled.div`
  max-width: 50vw;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    max-width: fit-content;
  }
`

const HeaderImage = styled.div`
  text-align: center;
  img {
    width: 100%;

    @media screen and (max-width: 768px) and (min-width: 601px) {
      width: 50%;
    }
  }
`

const CustomButtom = styled(Button)`
  padding: 18px 36px;
  a {
    padding: unset;
    height: auto;
  }

  @media screen and (max-width: 1024px) {
    button {
      font-size: 16px;
    }
  }
`

const SignupMailingListSubmitted = (props) => {
  const [pageText, setPageText] = React.useState([])

  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('facebook-host-success', language, setPageText)
  }, [])

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <>
      <Container>
        <Header>
          <CustomContainerFlexRow
            gap="50px"
            padding="12vh 40px 10vh 5vw"
            paddingSm="5vh 4vw 5vh 4vw"
          >
            <HeaderText>
              <Title
                size="2.5rem"
                sizemd="2.5rem"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[0]}`,
                }}
              ></Title>
              <Subtitle
                size="1.5rem"
                sizemd="1.5rem"
                margin="40px 0 0 0"
                marginmd="30px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[1]}`,
                }}
              />
              <Subtitle
                size="1.3rem"
                sizemd="1rem"
                margin="30px 0 0 0"
                marginmd="20px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[2]}`,
                }}
              />
              <CustomSubtitle
                size="1.3rem"
                sizemd="1rem"
                margin="30px 0 0 0"
                marginmd="22px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[3]}`,
                }}
              />
              <Subtitle
                size="1.3rem"
                sizemd="1rem"
                margin="30px 0 50px 0"
                marginmd="22px 0 36px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[4]}`,
                }}
              />
              <CustomButtom>
                <Link to="/">{pageText[5]}</Link>
              </CustomButtom>
            </HeaderText>
            <HeaderImage>
              <img src={'/images/facebook-host/header.png'} />
            </HeaderImage>
          </CustomContainerFlexRow>
        </Header>
      </Container>
    </>
  )
}

export default withRouter(withSearch(withAuth(SignupMailingListSubmitted)))
